import { render, staticRenderFns } from "./chatFooter.vue?vue&type=template&id=430b34bd&scoped=true&"
import script from "./chatFooter.vue?vue&type=script&lang=js&"
export * from "./chatFooter.vue?vue&type=script&lang=js&"
import style0 from "./chatFooter.vue?vue&type=style&index=0&id=430b34bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430b34bd",
  null
  
)

export default component.exports